import { FC, ReactElement, ReactNode } from 'react';
import Typography from '@egalite/ui/Typography';
import clx from 'classnames';

type Props = {
	children: ReactNode;
    title?: string;
    id?: string;
    bg?: string;
};

const Section: FC<Props> = ({ children, title, id, bg }) => {
	return (
		<section id={id} className={clx(bg && `bg-${bg}`)}>
            <div className="container py-40">
                {title && <Typography variant="h2" className="text-center !mb-40">
                    {title}
                </Typography>}
			    {children}
            </div>
		</section>
	);
};

export default Section;
